import api from "./api";

export interface Advertisement {
  id: number;
  _id: number;
  imageUri: string;
  link: string;
  professionalId?: number;
  active?: boolean;
}

export interface AdvertisementStats {
  clicks_by_day: { date: string; count: number }[];
  clicks_by_advertisement: {
    advertisement_id: number;
    link: string;
    count: number;
  }[];
  views_by_day: { date: string; count: number }[];
  views_by_advertisement: {
    advertisement_id: number;
    link: string;
    count: number;
  }[];
}

async function listProfessionalAds(
  professionalId: string | number
): Promise<Advertisement[]> {
  try {
    const { data } = await api.get(
      `/advertisements/professional/${professionalId}/`
    );
    return data;
  } catch (e) {
    console.error("Erro ao listar anúncios:", e);
    return [];
  }
}

async function createAdvertisement(
  professionalId: string | number,
  advertisement: { imageUri: string; link: string; active?: boolean }
): Promise<Advertisement | null> {
  try {
    const { data } = await api.post(
      `/advertisements/professional/${professionalId}/create/`,
      advertisement
    );
    return data;
  } catch (e) {
    console.error("Erro ao criar anúncio:", e);
    return null;
  }
}

async function updateAdvertisement(
  advertisementId: string | number,
  advertisement: { imageUri?: string; link?: string; active?: boolean }
): Promise<Advertisement | null> {
  try {
    const { data } = await api.put(
      `/advertisements/${advertisementId}/update/`,
      advertisement
    );
    return data;
  } catch (e) {
    console.error("Erro ao atualizar anúncio:", e);
    return null;
  }
}

async function deleteAdvertisement(
  advertisementId: string | number
): Promise<boolean> {
  try {
    await api.delete(`/advertisements/${advertisementId}/delete/`);
    return true;
  } catch (e) {
    console.error("Erro ao deletar anúncio:", e);
    return false;
  }
}

async function getStats(
  professionalId: string | number,
  days?: number
): Promise<AdvertisementStats | null> {
  try {
    const url = `/advertisements/stats/${professionalId}/${
      days ? `?days=${days}` : ""
    }`;
    const { data } = await api.get(url);
    return data;
  } catch (e) {
    console.error("Erro ao obter estatísticas:", e);
    return null;
  }
}

const advertisements = {
  listProfessionalAds,
  createAdvertisement,
  updateAdvertisement,
  deleteAdvertisement,
  getStats,
};

export default advertisements;
